import { TransportGroup } from './transport-group.model';

export class Transport {
  id: number;
  license_plate: string;
  destination_ubn: string;
  total_animals: number;
  departure_date_time_utc: string;
  transport_date?: string;
  kvs_departure_registered_at: string | null;
  kvs_departure_message_status: string | null;
  created_at: string;
  updated_at: string;
  group_count: number;
  destination_name: string;
  transport_groups: TransportGroup[];
}
